import { useTranslation } from "react-i18next";
import { body } from "../../../text/code-of-conduct";
import MarkdownPage from "../../common/markdown/MarkdownPage";
import MenuPage from "../menu-page/menu-page";

const CodeOfConduct = () => {
  const { t } = useTranslation("main");

  return (
    <MenuPage titles={[t("codeofconduct.headers.default")]}>
      <div className={"normal-case m-4 text-base font-comic"}>{body.code}</div>
    </MenuPage>
  );
};

export default CodeOfConduct;
